import React from 'react';
import LayoutInvest from "../Layout/LayoutInvest";
import InvestFAQElements from "./FAQElements";

function TradingFAQSource (props) {
        return (
            <LayoutInvest lang={props.lang}>
                    <InvestFAQElements AllFAQCategories={props.PrerenderFAQ} AllFAQElements={props.PrerenderFAQBase} lang={props.lang} data={props.data}/>

            </LayoutInvest>
        )}



export default TradingFAQSource